<div
  class="mx-auto w-full max-w-7xl animate-pulse px-4 py-8"
  role="status"
  aria-label="Loading analytics"
>
  <div class="mb-8 h-9 w-72 rounded bg-gray-200"></div>
  <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
    <div
      *ngFor="let item of [1, 2, 3, 4]"
      class="rounded-xl border border-gray-200 bg-white p-5 shadow-sm"
    >
      <div class="mb-4 h-3 w-24 rounded bg-gray-200"></div>
      <div class="h-8 w-20 rounded bg-gray-300"></div>
    </div>
  </div>
  <div class="mt-6 grid gap-6 lg:grid-cols-3">
    <div class="h-80 rounded-xl border border-gray-200 bg-white p-5 shadow-sm lg:col-span-2">
      <div class="mb-6 h-4 w-44 rounded bg-gray-200"></div>
      <div class="flex h-60 items-end gap-3">
        <div
          *ngFor="let height of [45, 70, 52, 88, 64, 76, 58]"
          class="flex-1 rounded-t bg-gray-200"
          [style.height.%]="height"
        ></div>
      </div>
    </div>
    <div class="h-80 rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
      <div class="mb-6 h-4 w-32 rounded bg-gray-200"></div>
      <div class="mx-auto h-52 w-52 rounded-full border-[28px] border-gray-200"></div>
    </div>
  </div>
  <span class="sr-only">Loading analytics...</span>
</div>
